import * as Yup from 'yup';


const createCatalogueMixture = Yup.object({
    name: Yup.string().required('Le nom est requis'),
    reagents: Yup.array().of(Yup.string()).required('Les réactifs sont requis'),
    category: Yup.string().required('La catégorie est requise'),
    subCategory: Yup.string().required('La sous-catégorie est requise'),
    dilution: Yup.string().required('La dilution est requise'),
    ref: Yup.number().required('La référence est requise').min(0, 'La référence doit être un nombre positif'),
    description: Yup.string().optional()
});

const createCustomMixture =
    Yup.object({
        name: Yup.string().required('Le nom est requis'),
        reagents: Yup.array().of(Yup.string()).required('Les réactifs sont requis'),
        category: Yup.string().required('La catégorie est requise'),
        subCategory: Yup.string().required('La sous-catégorie est requise'),
        dilution: Yup.string().required('La dilution est requise'),
        ref: Yup.string().required('La référence est requise'),
        description: Yup.string().optional()
    });

export default {
    createCatalogueMixture,
    createCustomMixture
};
